import { render, staticRenderFns } from "./ControleEnderecos.vue?vue&type=template&id=55ee0c20&scoped=true&"
import script from "./ControleEnderecos.vue?vue&type=script&lang=js&"
export * from "./ControleEnderecos.vue?vue&type=script&lang=js&"
import style0 from "./ControleEnderecos.vue?vue&type=style&index=0&id=55ee0c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee0c20",
  null
  
)

export default component.exports